import {ListUnorderedIcon, ProjectIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Label} from '@primer/react'

import type {Layout} from '../../utils/board-url-params'

interface SavedViewLayoutPickerProps {
  layout: Layout
  onSelectLayout: (next: Layout) => void
}

/**
 * Presentational List/Board layout menu. It renders the current layout and reports
 * selections through `onSelectLayout`; it holds no URL or navigation state itself.
 */
export function SavedViewLayoutPicker({layout, onSelectLayout}: SavedViewLayoutPickerProps) {
  const currentLayoutLabel = layout === 'board' ? 'Board' : 'List'
  const currentLayoutIcon = layout === 'board' ? ProjectIcon : ListUnorderedIcon

  return (
    <ActionMenu>
      <ActionMenu.Button aria-label={`${currentLayoutLabel}, layout selected`} leadingVisual={currentLayoutIcon}>
        {currentLayoutLabel}
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end" width="auto">
        <ActionList aria-label="Issue layout" selectionVariant="single">
          <ActionList.Item selected={layout === 'list'} onSelect={() => onSelectLayout('list')}>
            <ActionList.LeadingVisual>
              <ListUnorderedIcon />
            </ActionList.LeadingVisual>
            List
          </ActionList.Item>
          <ActionList.Item selected={layout === 'board'} onSelect={() => onSelectLayout('board')}>
            <ActionList.LeadingVisual>
              <ProjectIcon />
            </ActionList.LeadingVisual>
            Board
            <ActionList.TrailingVisual>
              <Label variant="success">Alpha</Label>
            </ActionList.TrailingVisual>
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
